import { Box } from "@mui/material";
import React from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import StlapFooter from "../CustomComponents/StlapFooter";
import { MandateReturnReducerAction } from "../Store/MandateReturnReducer";
import MandateReturnFilter from "./MandateReturnFilter";
import MandateReturnList from "./MandateReturnList";

const MandateReturn = () => {
  //Selectors from redux store
  const showMandateReturnList = useSelector(
    (state) => state.mandateReturn.showMandateReturnList
  );

  return (
    <React.Fragment>
      <Box style={{ minHeight: "calc(100vh - 120px)" }}>
        <MandateReturnFilter />
        {showMandateReturnList && <MandateReturnList />}
      </Box>
      <StlapFooter />
    </React.Fragment>
  );
};

export default MandateReturn;
